import { toSizeName } from "core/helpers";

import type { SizeTrimmed, SizeTrimmedAdapted } from "~/common/interfaces/size-trimmed";

export const sizeNormalize = (size: SizeTrimmed): SizeTrimmedAdapted => {
	const { width, height, length, ...rest } = size;

	return {
		...rest,
		name: toSizeName({ width, height, length }),
		width,
		height,
		length
	};
};
